import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { getURLParams } from 'js/utils/url.util';

export const useQueryObject = (): Record<string, string> => {
    const { search } = useLocation();

    return useMemo(() => getURLParams(search), [search]);
};
